/**
 * 用于存储需要复用的全局数据
 */
const store = {};

/**
 * @param {string} key
 * @return {Promise}
 */
function get(key) {
  if (!store[key]) {
    console.warn(`there is no key: ${key} in store`);
    return null;
  }
  return store[key];
}

/**
 *
 * @param {string} key
 * @param {Promise | Other} value
 */
function set(key, value) {
  if (isPromise(value)) {
    store[key] = value;
  } else {
    store[key] = Promise.resolve(value);
  }
}

function isPromise(target) {
  return typeof target === 'object' && typeof target.then === 'function';
}

export default {
  get,
  set,
};
